<template>
  <div class="parametr">
    <!-- {{attributes_active}}<br>
    {{dataValue}}<br>
    {{dataInputs}}<br>
    {{params[0]}} -->
    <div id="cards">

      <vue-slider
        v-model="value"
        @error="error"
        @change="onChangeSlider"
        :lazy="true"
        :tooltip="'always'"
        :tooltip-placement="['top', 'top']"
        :interval="(interval) ? Number(interval) : 0.1"
        :min="Number(value_min)"
        :max="Number(value_max)"
        :disabled='(params[0].count == 0) ? true : false'
      />

      <div class="form-inputs">
        <input class="form-control" v-model.lazy="value_input_min" @change="onChangeInput" :disabled='(params[0].count == 0) ? true : false'/>
        <span> - </span>
        <input class="form-control" v-model.lazy="value_input_max" @change="onChangeInput" :disabled='(params[0].count == 0) ? true : false' />
        <span>{{(suffix) ? suffix : ''}}</span>
        <span class="card-count" :class="((params[0].count == 0) ? 'noactive' : '')">({{params[0].count}})</span>
        <!-- <span style="font-size: 11px;  color: grey;">({{ params[0].count }})</span> -->
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
const ERROR_TYPE = {
    VALUE: 1,
    INTERVAL: 2,
    MIN: 3,
    MAX: 4,
    ORDER: 5,
}
export default {
  name: "FormSLider",
  props: ["params","inputType","tabName","suffix","interval","parentTranslation","toggle"], // ["tabId", "tabName", "param", "count", "quantity", "single"],
  data() {
    return {
      value: [0, 10000],
      value_min: 0,
      value_max: 10000,
      value_input_min: 0,
      value_input_max: 0,
      dataInputs: []
    };
  },
  computed: {
    ...mapGetters('products',["dataValue", "attributes_active"])
  },
  watch: {
    params (newValue, oldValue) {
      this.changeParams()
    },
    attributes_active (newValue) {
      // this.changeValuesAxios(newValue)
    }
  },
  methods: {
      error(type, msg) {
        switch (type) {
          case ERROR_TYPE.MIN:
            break
          case ERROR_TYPE.MAX:
            break
          case ERROR_TYPE.VALUE:
            break
        }
        this.errorMsg = msg
      },
      clearErrorMsg() {
        this.errorMsg = ''
      },
      changeParams () {
        if (this.params && this.params[0] && this.params[0].min && this.params[0].max) {
          this.value_min = Number(this.params[0].min)
          this.value_max = Number(this.params[0].max)
          this.value_input_min = Number(this.params[0].min)
          this.value_input_max = Number(this.params[0].max)
          // setTimeout(() => {
          this.value = [Number(this.params[0].min), Number(this.params[0].max)]
          // }, 200);
        }
      },
      changeValuesAxios (data) {
        // if (data[this.tabName]) {
        //   this.dataInputs = []
        //   data[this.tabName]['values'].forEach(element => {
        //     this.dataInputs.push([this.tabName, element])
        //   });
        // } else {
        //   this.dataInputs = []
        // }
      },
      onChangeSlider () {
        this.value_input_min = Number(this.value[0])
        this.value_input_max = Number(this.value[1])
        this.dataInputs = [this.tabName, [this.value[0],this.value[1]]];
        this.setDataValue([this.dataInputs])
      },
      onChangeInput (e) {
        this.value = JSON.parse(JSON.stringify([Number(this.value_input_min), Number(this.value_input_max)]))
        this.dataInputs = [this.tabName, this.value];
        this.setDataValue([this.dataInputs])
      },
      setDataValue (item) {
        var output = []
        item.forEach(element => {
          if(Array.isArray(element[1])) {
            output[element[0]] = []
            output[element[0]]['values'] = JSON.parse(JSON.stringify(element[1]))
            output[element[0]]['type'] = 'slider'
            output[element[0]]['translationParent'] = (this.parentTranslation && this.parentTranslation != '') ? this.parentTranslation : ''
          }
        });
        if (item.length == 0) {
          output[this.tabName] = []
        }
        this.$store.dispatch('products/set_data_values', output)
      }
  },
  created() {
    if (this.params && this.params[0] && this.params[0].min && this.params[0].max) {
      this.value_min = Number(this.params[0].min)
      this.value_max = Number(this.params[0].max)
      this.value_input_min = Number(this.params[0].min)
      this.value_input_max = Number(this.params[0].max)
      this.value = [Number(this.params[0].min), Number(this.params[0].max)]
    }
    if (this.toggle) {
      this.changeParams()
    }
  }
};
</script>

<style scoped>
.card-count {
  font-size: 11px;
  color: #5494ff;
}

.form-inputs {
  width: 100%;
  float:left;
  margin: 12px 0px;
}
.form-inputs span{
  color: #3498db;
  font-size: 12px;

}
.form-control {
  padding: 4px 12px;
  border: 2px solid #3498db;
  color: #3498db;
  border-radius: 6px;
  width: 60px;
  display: inline-flex;
}
  .card-value {
    display: inline;
  white-space: break-spaces;
  }
  /*============================ INPUT ============*/
  .noactive {
    color: rgb(214, 214, 214);
  }
  .vue-slider-dot-tooltip-inner {
    font-size: 11px;
  }
  .vue-slider {
   padding: 35px 15px 10px 15px !important;
    /* width: 400px !important; */
    height: 3px !important;
  }

  .inpMinMax {
    width: 65px !important;
    display: inline-block !important;
  }
  .inpValue {
    width: 100px !important;
  }
  .oddo {
    font-size: 18px !important;
    padding: 0px 38px !important;
    color: #888 !important;
  }
  #FormInput {
    margin-bottom: 20px !important;
  }
  #FormInput .md-field {
    margin: 0px 0px 0px 0px !important;
    padding-top: 0px !important;
    min-height: 0px !important;
    margin-bottom: 5px !important;
  }
  #FormInput .md-input {
    font-size: 15px !important;
    height: 21px !important;
  }
  #FormInput label {
    top: 12px !important;
    font-size: 14px !important;
    line-height: 0px !important;
    transition: 1s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  }
  #FormInput .md-has-value label {
    font-size: 11px !important;
  }
  .md-field.md-focused label,
  .md-field.md-has-value label {
    pointer-events: auto !important;
    opacity: 1 !important;
    right: 0px !important;
    display: block !important;
    text-align: end !important;
    top: 14px !important;
  }
  .md-list-item .md-list {
    margin: 0px;
  }
  .vue-slider-process {
    background-color: #448aff;
  }
  .vue-slider-dot-handle {
    border: 2px solid #448aff;
  }

  .md-list-item-text {
    display: inline-block !important;
  }

</style>




// WEBPACK FOOTER //
// src/components/fields/FormSlider.vue